import { render, staticRenderFns } from "./corpusDetailUploadDialog.vue?vue&type=template&id=f19dc372&scoped=true&"
import script from "./corpusDetailUploadDialog.vue?vue&type=script&lang=js&"
export * from "./corpusDetailUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./corpusDetailUploadDialog.vue?vue&type=style&index=0&id=f19dc372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19dc372",
  null
  
)

export default component.exports